// Utility to normalize boolean-like props (e.g., isDisabled)
// Accepts boolean, string ('true'/'false'), or other values
// Returns a proper boolean
export function normalizeBooleanProp(value: unknown): boolean {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true') {
      return true;
    }
    if (normalized === 'false') {
      return false;
    }
  }

  return false;
}
